import React from 'react'

const TradingPlans = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
      <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-6 sm:mb-8">
        Trading Plans
      </h1>
      <div className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 sm:p-8">
        <p className="text-gray-600 text-center">Trading plans coming soon...</p>
      </div>
    </div>
  )
}

export default TradingPlans